import { connect } from 'react-redux'
import { compose, withHandlers } from 'recompose'
import { cancelEditBalance } from 'src/actions/loan'
import { selectEditableLoanEstimatedBalance } from 'src/store/selectors/home/loans'

const EditBalanceContainer = compose(
  connect(
    state => ({
      estimatedValue: selectEditableLoanEstimatedBalance(state)
    }),
    dispatch => ({
      cancelEditBalance: () => dispatch(cancelEditBalance())
    })
  ),
  withHandlers({
    onCancel: ({ cancelEditBalance }) => () => cancelEditBalance()
  })
)

export default EditBalanceContainer
